import { createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.map.js";
import { tree } from "@/api/system/menu";
import { auth, getRoleAuth } from "@/api/system/role";
import { Dialog } from "@/component-create/Dialog";
import { MENU_STATUS, MENU_STYLE } from "@/constant/system/code";
import { toast } from "@/utils/message";
import { ElInput, ElTree, ElTag, ElButton, ElLoading } from 'element-plus';
import 'element-plus/es/components/input/style/css'
import 'element-plus/es/components/tree/style/css'
import 'element-plus/es/components/tag/style/css'
import 'element-plus/es/components/button/style/css'
import 'element-plus/es/components/loading/style/css'

let dialog = null;
export function renderAuthDialog(el) {
  dialog = new Dialog(el, AuthTree, '授权', '40%', [{
    el: el => {
      return h(_createVNode("div", null, [_createVNode(ElButton, {
        "onClick": () => {
          dialog?.close();
        }
      }, {
        default: () => [_createTextVNode("\u53D6\u6D88")]
      }), _createVNode(ElButton, {
        "type": "primary",
        "onClick": () => {
          submit(el);
        }
      }, {
        default: () => [_createTextVNode("\u6388\u6743")]
      })]));
    }
  }]);
  return dialog;
}
const AuthTree = defineComponent({
  props: {
    roleId: [String, Number]
  },
  setup(prop, {
    expose
  }) {
    const data = ref();
    const filter = ref('');
    const treeRef = ref();
    // 选中操作
    const grantedAction = ref([]);
    // 选中菜单
    const grantedMenu = ref([]);
    let loading = null;
    // 获取树形数据
    tree({
      action: true
    }).then(result => {
      data.value = setupMenusKey(result.data);
      console.log(data.value);
    });
    watch(() => prop.roleId, newVal => {
      if (newVal) {
        filter.value = '';
        // 获取选中节点
        getRoleAuth(newVal).then(res => {
          if (treeRef.value) {
            grantedAction.value = res.data.grantedAction.map(item => item.id + MENU_STYLE.ACTION);
            grantedMenu.value = res.data.grantedMenu.map(item => item.id + MENU_STYLE.MENU);
            treeRef.value.setCheckedKeys([...grantedAction.value, ...grantedMenu.value]);
          }
        });
      }
    }, {
      immediate: true
    });
    watch(filter, val => {
      treeRef.value.filter(val);
    });
    onMounted(() => {
      // 初始化选中节点
      if (treeRef.value) {
        treeRef.value.setCheckedKeys([...grantedAction.value, ...grantedMenu.value]);
      }
    });
    function filterAuthTree(value, data) {
      if (!value) return true;
      return data.menuName.indexOf(value) !== -1;
    }
    // 获取选中数据
    function getCheckedKeys() {
      if (treeRef.value) {
        return treeRef.value.getCheckedKeys();
      }
      return [];
    }
    function getRoleId() {
      return prop.roleId;
    }
    function loadingStart() {
      loading = ElLoading.service({
        target: treeRef.value.$el
      });
    }
    function loadingEnd() {
      loading.close();
    }
    expose({
      getCheckedKeys,
      getRoleId,
      loadingStart,
      loadingEnd
    });
    // 自定义节点内容
    const renderContent = (h, {
      node,
      data
    }) => {
      return h(_createVNode("span", {
        "style": {
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          fontSize: '14px',
          paddingRight: '8px'
        }
      }, [data.status === MENU_STATUS.DISABLED.CODE ? _createVNode("span", {
        "style": {
          color: 'darkgray'
        }
      }, [node.label]) : _createVNode("span", null, [node.label]), _createVNode("span", {
        "class": "custom-tree-node-tag"
      }, [data.status === MENU_STATUS.DISABLED.CODE ? _createVNode(ElTag, {
        "type": "danger",
        "size": "small",
        "style": "margin-right: 10px"
      }, {
        default: () => [_createTextVNode("\u5DF2\u505C\u7528")]
      }) : _createVNode("span", null, null), data.menuStyle === MENU_STYLE.CATALOG ? _createVNode(ElTag, {
        "size": "small"
      }, {
        default: () => [_createTextVNode("\u76EE\u5F55")]
      }) : data.menuStyle === MENU_STYLE.MENU ? _createVNode(ElTag, {
        "type": "success",
        "size": "small"
      }, {
        default: () => [_createTextVNode("\u83DC\u5355")]
      }) : _createVNode(ElTag, {
        "type": "info",
        "size": "small"
      }, {
        default: () => [_createTextVNode("\u64CD\u4F5C")]
      })])]));
    };
    return () => _createVNode("div", null, [_createVNode(ElInput, {
      "modelValue": filter.value,
      "onUpdate:modelValue": $event => filter.value = $event,
      "placeholder": "\u8F93\u5165\u5173\u952E\u8BCD\u8FDB\u884C\u8FC7\u6EE4"
    }, null), _createVNode(ElTree, {
      "check-strictly": true,
      "ref": treeRef,
      "data": data.value,
      "props": {
        label: 'menuName'
      },
      "node-key": "key",
      "show-checkbox": true,
      "highlight-current": true,
      "style": "margin-top: 10px",
      "render-content": renderContent,
      "expand-on-click-node": true,
      "filter-node-method": filterAuthTree
    }, null)]);
  }
});
// 提交
function submit(el) {
  console.log(el.value);
  const keys = el.value.getCheckedKeys();
  const resultAction = keys.filter(id => id.includes(MENU_STYLE.ACTION)).map(id => ({
    id: Number(id.replace(MENU_STYLE.ACTION, ''))
  }));
  const resultMenu = keys.filter(id => id.includes(MENU_STYLE.MENU)).map(id => ({
    id: Number(id.replace(MENU_STYLE.MENU, ''))
  }));
  el.value.loadingStart();
  auth({
    roleId: el.value.getRoleId(),
    grantedMenu: resultMenu,
    grantedAction: resultAction
  }).then(() => {
    toast.success('授权成功');
    if (dialog) {
      dialog.close();
    }
  }).finally(() => {
    el.value.loadingEnd();
  });
}
// 构造key
function setupMenusKey(menus) {
  const result = [];
  if (!menus || menus.length < 1) {
    return result;
  }
  for (const menu of menus) {
    if (menu.children && menu.children.length > 0) {
      menu.children = setupMenusKey(menu.children);
    }
    menu.key = menu.menuStyle === MENU_STYLE.CATALOG ? menu.id + MENU_STYLE.MENU : menu.id + menu.menuStyle;
    result.push(menu);
  }
  return result;
}